import { createContext, type FC, useContext, type ReactNode } from 'react';

export const ServerVarsContext = createContext<ServerVarsContextProviderProps>({});

export type ServerVarsContextProviderProps = {
    isDesktop?: boolean;
    isMobile?: boolean;
    isTablet?: boolean;
    originalUrl?: string;
    areDisplayAdsEnabled?: boolean;
    tradeBenefitsVideoPlaybackId?: string;
};

export const ServerVarsContextProvider: FC<
    ServerVarsContextProviderProps & { children: ReactNode }
> = ({
    children,
    isDesktop,
    isMobile,
    isTablet,
    originalUrl,
    areDisplayAdsEnabled,
    tradeBenefitsVideoPlaybackId,
}) => (
    <ServerVarsContext
        value={{
            isDesktop,
            isMobile,
            isTablet,
            originalUrl,
            areDisplayAdsEnabled,
            tradeBenefitsVideoPlaybackId,
        }}
    >
        {children}
    </ServerVarsContext>
);

export function useServerVars(): ServerVarsContextProviderProps {
    return useContext(ServerVarsContext);
}
